// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@adl/App/Components/Notify";
import { xScreen } from "@adl/XDL/Utilities";
import { userListUsersTableStyles } from "@insite/content-library/Widgets/UserList/UserListUsersTable";
import { css } from "styled-components";

userListUsersTableStyles.noResultsText = {
    ...getNotifyStyle("danger"),
};

// Remove default style
userListUsersTableStyles.noResultsContainer = {
    css: css``,
};

userListUsersTableStyles.dataTable = {
    cssOverrides: {
        cell: css`
            ${xScreen("lte", "sm")} {
                &:first-child {
                    position: relative;
                    left: 0;
                }
            }
        `,
        head: css`
            ${xScreen("lte", "sm")} {
                th:first-child {
                    position: relative;
                    left: 0;
                }
            }
        `,
    },
};

userListUsersTableStyles.pagination = {
    cssOverrides: {
        pagination: css`
            margin-top: 10px;
        `,
    },
};
